import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

import NewStandardRequest from "../../ServiceAndSlots/Standard/NewApprovalRequest/NewStandardRequest";
import NewExpressRequest from "../../ServiceAndSlots/Express/NewApprovalRequest/NewExpressRequest";

import { selectServiceTypes } from "../../../config/redux/configurationsSlice";
import { APP_ROUTES, SERVICE_TYPES } from "../../../config/constants";

import { getServiceTypeDetailsFromServiceName } from "../../../utils/helperFunctions";

const NewRequestForServiceAndSlot = () => {
  const basePath = "";

  const serviceTypes = useSelector(selectServiceTypes);

  const standardServiceTypeId = useMemo(
    () => getServiceTypeDetailsFromServiceName(serviceTypes, SERVICE_TYPES.STANDARD)?.id,
    [serviceTypes]
  );
  const expressServiceTypeId = useMemo(
    () => getServiceTypeDetailsFromServiceName(serviceTypes, SERVICE_TYPES.EXPRESS)?.id,
    [serviceTypes]
  );

  if (!serviceTypes?.length) {
    return <div>Loading service configurations...</div>;
  }

  return (
    <Routes>
      <Route
        path={`${basePath}${APP_ROUTES.STANDARD}/:posNo/:zoneId?`}
        element={
          <NewStandardRequest
            serviceTypeId={standardServiceTypeId}
            serviceTypeName={SERVICE_TYPES.STANDARD.toLowerCase()}
          />
        }
      />
      <Route
        path={`${basePath}${APP_ROUTES.EXPRESS}/:posNo/:zoneId?`}
        element={
          <NewExpressRequest
            serviceTypeId={expressServiceTypeId}
            serviceTypeName={SERVICE_TYPES.EXPRESS.toLowerCase()}
          />
        }
      />
    </Routes>
  );
};

export default React.memo(NewRequestForServiceAndSlot);
